import { omit } from 'lodash';

export function removeHiddenColumns(columns) {
  const hiddenColumns = Object.keys(columns).filter((column) => columns[column].hidden);
  return omit(columns, hiddenColumns);
}

export function buildStyleFunctions(columnsData, styles) {
  return Object.keys(columnsData).reduce((allColumnsData, columnKey) => {
    if (columnsData[columnKey].style) {
      columnsData[columnKey].styleFunction = () => styles[columnsData[columnKey].style];
    }
    allColumnsData[columnKey] = columnsData[columnKey];
    return allColumnsData;
  }, {});
}

export function getDefaultColumns(columns) {
  const defaultColumns = Object.keys(columns).filter((column) => !columns[column].isDefault);
  const hasDefaultColumns = defaultColumns.length < Object.keys(columns).length;
  return Object.keys(hasDefaultColumns ? omit(columns, defaultColumns) : columns);
}
